import React, { memo } from 'react'

import { TRANSFER_NFTS_PROFILE_DISPATCH } from '../../store/reducers/nft/transferNft'
import customConfig from 'customConfig'
import Popup from '../shared/popup/Popup'
import CustomTextField from '../shared/inputs/CustomTextField'

const TransferNft = ({
  t,
  tokenName,
  onFormSubmit,
  dispatchAction,
  transferNftProfile: { accountNumber, error },
  onCancel
}) => {
  return (
    <Popup
      title={t(customConfig.transferYourNftLabel)}
      description={t(customConfig.transferNftDescLabel, { name: tokenName })}
      submitLabel={t(customConfig.transferNftLabel)}
      onFormSubmit={onFormSubmit}
      cancelLabel={t('common.cancel')}
      onCancel={onCancel}
    >
      <CustomTextField
        label={t('nft.enter-account-number')}
        error={t(error[TRANSFER_NFTS_PROFILE_DISPATCH.ACCOUNT_NUMBER])}
        value={accountNumber}
        onChange={(value) =>
          dispatchAction(TRANSFER_NFTS_PROFILE_DISPATCH.ACCOUNT_NUMBER, value)
        }
        sx={{ mt: 2 }}
      />
    </Popup>
  )
}

export default memo(TransferNft)
